import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ReduxStateType } from "redux-store/types";

import { CroppedFilePayload } from "core/http/service/accountInfo/paramsTypes";

interface InitialState {
  status: ReduxStateType;
  data: any;
}

const initialState: InitialState = {
  status: ReduxStateType.ERROR,
  data: {},
};

const changeImageBirthdaySlice = createSlice({
  name: "changeImageBirthday",
  initialState,
  reducers: {
    changeImageBirthdayStart: (
      state,
      action: PayloadAction<CroppedFilePayload>
    ) => {
      state.status = ReduxStateType.LOADING;
    },
    changeImageBirthdaySuccess: (state) => {
      state.status = ReduxStateType.SUCCESS;
    },
    changeImageBirthdayFailed: (state) => {
      state.status = ReduxStateType.ERROR;
    },
  },
});

export const {
  changeImageBirthdayStart,
  changeImageBirthdaySuccess,
  changeImageBirthdayFailed,
} = changeImageBirthdaySlice.actions;

export default changeImageBirthdaySlice.reducer;
